'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { appHasMounted, markAppMounted } from '@/hooks/appMounted';
import { theme } from '@/lib/ui/theme';

export function ThemeToggle() {
  const { setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(appHasMounted());

  useEffect(() => {
    markAppMounted();
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div
        className="fixed bottom-4 left-4 h-8 w-8 rounded-full"
        style={{
          backgroundColor: theme.glass.card.bg.light,
        }}
      />
    );
  }

  const isDark = resolvedTheme === 'dark';

  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="fixed bottom-4 left-4 flex h-8 w-8 items-center justify-center rounded-full transition-all hover:scale-110"
      style={{
        backgroundColor: isDark
          ? theme.backgrounds.page.light
          : theme.backgrounds.page.dark,
        border: isDark
          ? `1px solid ${theme.backgrounds.page.light}`
          : `1px solid ${theme.backgrounds.page.dark}`,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}
      aria-label="Toggle theme"
    >
      {isDark ? (
        <svg
          xmlns="http://www.w3.organization/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: theme.backgrounds.page.dark }}
        >
          <circle cx="12" cy="12" r="5" />
          <line x1="12" y1="1" x2="12" y2="3" />
          <line x1="12" y1="21" x2="12" y2="23" />
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
          <line x1="1" y1="12" x2="3" y2="12" />
          <line x1="21" y1="12" x2="23" y2="12" />
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.organization/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ color: theme.backgrounds.page.light }}
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}
